// The keys for the whole cache system
export class Cache {


    public static PRELOAD_MAP = "preload.map";
    public static EVENT_CATEGORIES = "event.categories";
    public static RESULT_CATEGORIES = "result.categories";
    public static PROFILE_CATEGORIES = "profile.categories";
    public static ALL_CATEGORIES = "all.categories";
    public static TREES = "get.trees";
    public static CLIENT_EVENTS_ENA = "client.events.ena";
    public static CLIENT_EVENTS = "client.events";
    public static CLIENT_EVENTS_ENA_LID = "client.events.ena.lid";
    public static MY_EVENTS = "my.events";
    public static MY_TRAININGS = "my.trainings";
    public static RANGLIST_ID = "ranglist.id";
    public static TEAM_LIST = "team.list";
    public static TOTAL_LIST = "total.list";
    public static RANGLIST = "rang.list";
    public static RANGLIST_THURNAU = "rang.list.thurnau";
    public static EVENT_DETAILS = "event.details";
    public static IS_ADMIN = "is.admin";
    public static NEWS_KEY = "news.key";
    public static SEARCH_RESULTS = "search.results";
    public static SEARCH_RESULTS_CLIENT = "search.results.client";
    public static EVENT_CLIENT_NAMES = "event.client.names";
    public static EVENT_CLIENT_DISTANCES = "event.client.distances";
    public static EVENT_CLIENT_TYPES = "event.client.types";
    public static EVENT_DATES_RESULTS = "event.dates.results";
    public static USER_RESULTS = "user.results";
    public static USER_EVENT_TYPE_RESULTS = "user.event.type.results";
    public static ATH_WITH_PARAMS = "ath.with.params";
    public static USER_PIC_BY_ID = "user.pic.by.id";
    public static MY_RESULTS_BY_TOKEN = "my.results.by.token";
    public static PUBLIC_PROFILE_ID = "public.profile.id";
    public static ENDURANCES_SIMPLE = "public.endurances.simple";
    public static MAP_BY_LID = "map.by.lid";
    public static MYSHIRTS_PHOTOS = "myshirts.spooorts";
    public static NEARBY_BY_EVENTS = "nearby.by.events";
    public static NEARBY_EVENT_ID = "nearby.event.id";
    public static MONTHLY_STATE_STATS = "monthly.stats.year.cid";
    public static MONTHLY_STATE_STAST_CID = "monthly.stats.year.cid.nonth";
    public static FRIENDS_MY_TOKEN = "friends.token.my";
    public static MYPICS_FANS = "my.fans.photos";
    public static MYPICS_PHOTOS = "my.pics.photos";
    public static MYBIBS_PHOTOS = "bibpics.spooorts";
    public static UTRAIN_KEY = "utrain.spooorts";
    public static PAYMENT_DETAILS = "pymt.spooorts";
    public static INVITE_FRIEND_ROUTE = "participant.list.invite";
    public static REGISTRATION_CONFIRMATION = "isusrreg.spooorts";
    public static EVENT_ID_BY_DETAILS = "eid.spooorts";
    public static PRIVATE_PROFILE = "private.profile.spooorts";
    public static REGISTRATION_FOR_EVENT = "registevt.spooorts";
    public static BACKGROUNDS_PICTURES = "backgrounds.profile.token.spooorts";
    public static PROFILE_TOKEN = "profile.token.spooorts";
    public static MY_ROUTES = "mysport.my.routes";
    public static ROUTE_PICS = "mysport.my.routes.pics";
    public static SPONSOR_IMAGES = "global.sponsor.images";
    public static GET_POS_NEARBY = "get.pos.nearby";
    public static QR_CODE_BY_TOKEN = "qr.code.by.token";
    public static QR_CODE_BY_TOKEN_AND_EVID = "qr.code.by.token.and.evid";
    public static TRACKING_SETTINGS = "tracking_settings.service.ts";
    public static CATS_RESULTS_LID = "categories.results.lid";
}


// WEBPACK FOOTER //
// /src/assets/data/cache-key/cache-key.ts